import { discardHTMLTags, getBaseImageUrl } from '@/constants/hooks';
import { OffersMerchant, OffersOffer } from '@/services/dataTypes';
import Image from 'next/image'
import React from 'react'

interface Props {
    data: OffersOffer;
    merchant?: OffersMerchant;
    height?: number;
    offerLink?: string | null;
    mer_slug?: string;
    slug_type?: string;
    domain: string;
    unoptimized?: boolean;
    width?: number;
}

const Banner = ({ data, height, offerLink, mer_slug, slug_type, domain, unoptimized = false, width }: Props) => {
    const { offer_title, offer_detail, banner_image, url } = data?.offer ?? {};

    return (
        <div className="p-3 mb-4">
            <div className="w-full flex items-center justify-center relative bg-white rounded-lg border border-slate-200 overflow-hidden hover:shadow-lg transition-shadow">
                <Image
                    src={getBaseImageUrl(domain, banner_image, "")}
                    alt={discardHTMLTags(offer_detail || offer_title) || `${data?.merchant?.merchant_name || 'Store'} discount coupons and deals`}
                    className="object-contain"
                    loading='lazy'
                    height={height}
                    width={width}
                />
            </div>
        </div>
    )
};

export default Banner